// src/utils/api.js
// Production talks to the API directly. During `npm start` requests go through
// the dev-server proxy (src/setupProxy.js) so login cookies work on localhost.
// Set REACT_APP_API_URL to override either one.
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "development" ? "/api/" : "https://api.econovda.uz/api/");

export const API_ENDPOINTS = {
  AUTH: "auth/",
  LOGOUT: "logout/",
  PRODUCTS: "products/",
};
